import { $, Foundation } from "../../../vendor";
import InboomaBaseView from "../InboomaBaseView";
import { getContentModifications } from "../../App";

import ReservationsSortTabsTpl from "../../templates/reservationsList/ReservationsSortTabsTpl.html";

export default InboomaBaseView.extend({
  template: ReservationsSortTabsTpl,
  el: "#inb-c-main-sort-nav",

  events: {
    "click li.tabs-title": "_changeCollectionSort",
  },

  templateContext() {
    return {
      _exchangeLabel: (value) => {
        let cm = getContentModifications();

        if (cm.labels != null) {
          if (cm.labels[value] !== undefined) {
            return cm.labels[value];
          }
        }
        return value;
      },

      isHiddenElement: (id) => {
        let cm = getContentModifications();

        if (cm.hidden_elements != null && cm.hidden_elements.length > 0) {
          for (var i = 0; i < cm.hidden_elements.length; i++) {
            if (cm.hidden_elements[i] == id) return true;
          }
        }
        return false;
      },
    };
  },

  initialize() {
    this.render();
  },

  onRender() {
    // https://foundation.zurb.com/sites/docs/sticky.html
    Foundation.Sticky.defaults.marginTop = 0;
    const meSoSticky = new Foundation.Sticky(this.$el);
  },

  _changeCollectionSort(el) {
    el = $(el.currentTarget);

    const val = el.attr("data-inb-val"),
      direction = el.attr("data-inb-direction");

    if (typeof val === "undefined" || direction === "undefined") {
      return;
    }

    el.parent().find(".is-active").removeClass("is-active");

    el.addClass("is-active");

    el.attr("data-inb-direction", direction === "desc" ? "asc" : "desc");

    this.collection.setSortWithRequest(val, direction);

    return false;
  },
});
